module.exports = __webpack_public_path__ + "/static/assets/ae12a91b2e503153573433fd0e78dd85.gif";